/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export {
  JaegerPropagator,
  UBER_BAGGAGE_HEADER_PREFIX,
  UBER_TRACE_ID_HEADER,
} from './JaegerPropagator';
